export default __webpack_public_path__ + "static/media/tetrahedron.be5056ca.usdz";